<nav id="step-home-sidebar" class="global-sidebar" [class.global-sidebar--collapsed]="!expanded()" aria-label="Main navigation">
  <div class="global-sidebar__brand" (click)="goHome()" role="button" tabindex="0" (keydown.enter)="goHome()">
    <span class="global-sidebar__logo"><mat-icon fontIcon="stream"></mat-icon></span>
    @if (expanded()) {
      <span class="global-sidebar__brand-name">{{ 'HOME.HEADER.NAME' | translate }}</span>
    }
  </div>

  <button class="global-sidebar__toggle" data-fs-element="Global-Sidebar-Button-Toggle" type="button" (click)="toggle()" [attr.aria-expanded]="expanded()"
    aria-controls="global-sidebar-links" [matTooltip]="expanded() ? ('OPEN_SEARCH.COLLAPSE_MENU' | translate) : ('OPEN_SEARCH.EXPAND_MENU' | translate)">
    <mat-icon fontIcon="code"></mat-icon>
  </button>

  <div id="global-sidebar-links" class="global-sidebar__links">
    <div class="global-sidebar__group">
      <div class="global-sidebar__section"><span>{{ 'OPEN_SEARCH.HOME' | translate }}</span></div>
      <button type="button" class="global-sidebar__item" data-fs-element="Global-Sidebar-Button-Home" [class.active]="isHome()" (click)="goHome()"
        [attr.aria-current]="isHome() ? 'page' : null" [matTooltip]="expanded() ? '' : ('OPEN_SEARCH.HOME' | translate)">
        <mat-icon class="material-icons-outlined">home</mat-icon>
        @if (expanded()) { <span>{{ 'OPEN_SEARCH.HOME' | translate }}</span> }
      </button>
    </div>

    <div class="global-sidebar__group">
      <div class="global-sidebar__section"><span>{{ 'OPEN_SEARCH.KNOWLEDGE_ASSISTANT' | translate }}</span></div>
      <button type="button" class="global-sidebar__item global-sidebar__item--assistant" data-fs-element="Global-Sidebar-Button-Assistant" [class.active]="isOpenSearch()" (click)="openAssistant()"
        [attr.aria-current]="isOpenSearch() ? 'page' : null" [matTooltip]="expanded() ? '' : ('OPEN_SEARCH.KNOWLEDGE_ASSISTANT' | translate)">
        <mat-icon>auto_fix_high</mat-icon>
        @if (expanded()) { <span>{{ 'OPEN_SEARCH.KNOWLEDGE_ASSISTANT' | translate }}</span> }
      </button>
      <button type="button" class="global-sidebar__item" data-fs-element="Global-Sidebar-Button-Recent-Searches" [class.active]="isRecentSearch()" (click)="openRecent()"
        [attr.aria-current]="isRecentSearch() ? 'page' : null"
        [matTooltip]="expanded() ? '' : ('OPEN_SEARCH.RECENT_SEARCH' | translate)">
        <mat-icon>bookmark</mat-icon>
        @if (expanded()) { <span>{{ 'OPEN_SEARCH.RECENT_SEARCH' | translate }}</span> }
      </button>
    </div>

    @if (showLessonsOptions()) {
    <div class="global-sidebar__group">
      <div class="global-sidebar__section"><span>{{ 'OPEN_SEARCH.LESSONS_ASSISTANT' | translate }}</span></div>
      <button type="button" class="global-sidebar__item" data-fs-element="Global-Sidebar-Button-Lessons" [class.active]="isLessons()" (click)="openLessons()"
        [attr.aria-current]="isLessons() ? 'page' : null" [matTooltip]="expanded() ? '' : ('OPEN_SEARCH.LESSONS_ASSISTANT' | translate)">
        <mat-icon class="material-symbols-outlined">contract</mat-icon>
        @if (expanded()) { <span>{{ 'OPEN_SEARCH.LESSONS_ASSISTANT' | translate }}</span> }
      </button>
      <button mat-flat-button color="primary" type="button" class="global-sidebar__create btn-small body-small bold" data-fs-element="Global-Sidebar-Button-Create-Lesson" [class.active]="isLessonForm()" (click)="openLessonForm()" [matTooltip]="expanded() ? '' : ('OPEN_SEARCH.CREATE_LESSON' | translate)">
        <mat-icon class="material-symbols-outlined">contract_edit</mat-icon>
        @if (expanded()) { <span>{{ 'HOMEMODALS.CREATELESSONBUTTON' | translate }}</span> }
      </button>
    </div>
    }
  </div>
</nav>
